import { Component, ElementRef, input, viewChild } from '@angular/core';
import { ModalIconComponent, ModalIconType } from "../modal-icon/modal-icon.component";
import { ButtonComponent, ButtonTypes } from "../button/button.component";
import { NgClass } from "@angular/common";

@Component({
  selector: 'dialog-modal',
  imports: [
    ModalIconComponent,
    ButtonComponent,
    NgClass
  ],
  templateUrl: './dialog-modal.component.html',
  styleUrl: './dialog-modal.component.scss'
})
export class DialogModalComponent {
  dom_modal = viewChild.required<ElementRef>('modal');

  options = input<DialogModalOptions>({
    title: 'Default title',
    subTitle: '',
    maxWidth: 400,
    showBackDrop: true,
    disableClose: false,
    hasCloseIcon: false,
    positiveText: '',
    positiveType: 'primary',
    negativeText: 'Close',
    negativeType: 'secondary',
    iconPreset: 'default',
  });

  ngOnInit() {
    const reset =this.options().resetFunction;
    this.dom_modal().nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape' && this.options().disableClose) {
        event.stopPropagation();
        event.preventDefault();
      }
      else if(event.key === 'Escape' && reset){
        reset()
      }
    });
  }

  executeAction(action: 'positive' | 'negative') {
    const fn = action == 'positive'
      ?  this.options().onPositiveClick
      :  this.options().onNegativeClick;
    if (fn) fn();

    if (!this.options().disableClose) {
      this.onDismiss();
    }
  }

  onDismiss() {
    if (this.options().disableClose) return;
    this.dom_modal().nativeElement.close();

    const reset = this.options().resetFunction
    if (reset) reset();

  }

  onShow() {
    this.dom_modal().nativeElement.showModal();
  }
}

export interface DialogModalOptions {
  title: string;
  subTitle?: string;
  maxWidth?: number;
  showBackDrop?: boolean;
  disableClose?: boolean;
  hasCloseIcon?: boolean;
  resetFunction?: () => void; // if a form needs to be reset on dismiss

  // buttons
  positiveText?: string;
  positiveType?: ButtonTypes;
  positiveDisabled?: boolean;
  onPositiveClick?: () => void;

  negativeText?: string;
  negativeType?: ButtonTypes;
  negativeDisabled?: boolean;
  onNegativeClick?: () => void;

  // modal icon config
  iconPreset?: ModalIconType; // overrides bi_icon and iconType
  bi_icon?: string;
  iconType?: ModalIconType;
}
